module.exports = __webpack_public_path__ + "static/media/Endbright use telemedicine software for digital healthcare.fe75d7ef.webp";